'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@//components/Link';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';
import styles from './ContactEmailBox.module.scss';

export const ContactEmailBox = () => {
  const marketMetadata = useMarketMetadata();
  const t = useTranslations('pages.faq.contact');

  const headingId = 'contact-email-box-heading';

  return (
    <aside className={styles.box} aria-labelledby={headingId}>
      <h3 className={styles.heading} id={headingId}>
        {t('heading')}
      </h3>
      <p className={styles.description}>
        {t('description')}{' '}
        <Link
          href={`mailto:${marketMetadata.customerServiceEmail}`}
          title={t('emailTitle', {
            email: marketMetadata.customerServiceEmail,
          })}
          prefetch="none"
        >
          {marketMetadata.customerServiceEmail}
        </Link>
      </p>
    </aside>
  );
};
